import Modal from './modal';
import Input from './input';
import Prompt from './prompt';
import Instructions from './instructions';
import Information from './information';
Modal.Input = Input;
Modal.Prompt = Prompt;
Modal.Instructions = Instructions;
Modal.Information = Information;
export default Modal;
//# sourceMappingURL=index.js.map